
import $ from 'jquery';

$(function () {

    var $form = $('.form--assessment');
    var $radios = $form.find('input[type="radio"]');
    var $submit = $('.assessment-submit');

    $radios.on('change', onChange);
    $submit.on('click touch', onSubmit);

    function onChange() {
        console.info('Selections Updated', $('input[type="radio"]:checked'));
    }

    function onSubmit() {
        window.print();
    }

});
